import request from '../../http/request'
import { getPreUrl } from '../../utils/common'
const preUrl = getPreUrl('8082')

export const getCartonList = (params, queryHeader) => {
  console.log('params', queryHeader)
  return request.get(`${preUrl}/nfc-clc-service/api/nfc/tag/tagPreCheck`, {
    params,
    RFHeader: queryHeader
  })
}

export const pfTagBinding = params => {
  return request.post(`${preUrl}/nfc-clc-service/api/nfc/tag/binding/nddc`, params, {
    PFTagBinding: true
  })
}

export const nddcBindForPhone = (params, queryHeader) => {
  return request.post(`${preUrl}/nfc-clc-service/nfc/rf/device/nddc/bind`, params, {
    nfc: true,
    // noSpin: true,
    RFHeader: queryHeader
  })
}
